import React, { useState } from 'react';
import { useToast } from '../hooks/useToast';
import Toast from '../components/Toast';
import './Inner.css';

function validate(f) {
  const e = {};
  if (!f.name.trim())    e.name    = 'Name is required.';
  if (!f.email.trim())   e.email   = 'Email is required.';
  if (!f.message.trim()) e.message = 'Message is required.';
  return e;
}

export function Contact() {
  const { toasts, toast } = useToast();
  const [form, setForm]   = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [done, setDone]   = useState(false);

  const set = (k, v) => {
    setForm(f => ({ ...f, [k]: v }));
    setErrors(e => ({ ...e, [k]: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate(form);
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setLoading(true);
    await new Promise(r => setTimeout(r, 800));
    setLoading(false);
    setDone(true);
    toast("Message sent! We'll reply within 24 hours.", 'success');
  };

  const contactItems = [
    { icon: '✉️', label: 'Email',    val: 'info@nextgenhub.life',   href: 'mailto:info@nextgenhub.life' },
    { icon: '📞', label: 'Phone',    val: '+91 7428951184',    href: 'tel:+919999999999' },
    { icon: '💬', label: 'WhatsApp', val: 'Chat with us',       href: 'https://wa.me/917428951184' },
    { icon: '📍', label: 'Location', val: 'Noida, India', href: null },
  ];

  return (
    <>
      <Toast toasts={toasts} />
      <div>
        <section className="page-hero" style={{ textAlign: 'center' }}>
          <div className="ph-orb ph-orb-1" />
          <div className="ph-orb ph-orb-2" />
          <div className="container page-hero-inner">
            <div className="badge"><div className="badge-dot">✦</div>Get in touch</div>
            <h1 className="ph-title">Let's <span className="grad-text">talk</span></h1>
            <p className="ph-sub">
              Whether you have a project in mind or just want to explore — we're always happy to chat.
            </p>
          </div>
        </section>

        <section className="section">
          <div className="container">
            <div className="contact-wrap">
              {/* Left: info */}
              <div className="contact-info">
                {contactItems.map(c => (
                  <div key={c.label} className="ci-card">
                    <div className="ci-icon">{c.icon}</div>
                    <div>
                      <div className="ci-label">{c.label}</div>
                      {c.href
                        ? <a href={c.href} className="ci-val link" target={c.href.startsWith('http') ? '_blank' : undefined} rel="noopener noreferrer">{c.val}</a>
                        : <div className="ci-val">{c.val}</div>
                      }
                    </div>
                  </div>
                ))}
                <div className="ci-hours">
                  <div className="ci-label">Working hours</div>
                  <div className="ci-val">Mon – Fri, 9:00 AM – 7:00 PM IST</div>
                  <div className="ci-note">We typically respond within 2 hours during business hours.</div>
                </div>
              </div>

              {/* Right: form */}
              <div className="contact-form-card">
                {done ? (
                  <div className="contact-done">
                    <div className="cd-icon">✉️</div>
                    <h3>Message sent!</h3>
                    <p>Thanks {form.name.split(' ')[0]}. We'll get back to you within 24 hours.</p>
                    <button
                      onClick={() => { setDone(false); setForm({ name:'',email:'',phone:'',subject:'',message:'' }); }}
                      className="btn-out"
                      style={{ marginTop: 16 }}
                    >
                      Send another message
                    </button>
                  </div>
                ) : (
                  <>
                    <h2>Send us a message</h2>
                    <form onSubmit={handleSubmit} noValidate>
                      <div className="qf-row">
                        <div className="fg">
                          <label>Name *</label>
                          <input value={form.name} onChange={e => set('name', e.target.value)} placeholder="" className={errors.name ? 'error' : ''} />
                          {errors.name && <div className="field-error">{errors.name}</div>}
                        </div>
                        <div className="fg">
                          <label>Email *</label>
                          <input type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="" className={errors.email ? 'error' : ''} />
                          {errors.email && <div className="field-error">{errors.email}</div>}
                        </div>
                      </div>
                      <div className="qf-row">
                        <div className="fg">
                          <label>Phone</label>
                          <input value={form.phone} onChange={e => set('phone', e.target.value)} placeholder="" />
                        </div>
                        <div className="fg">
                          <label>Subject</label>
                          <input value={form.subject} onChange={e => set('subject', e.target.value)} placeholder="What's this about?" />
                        </div>
                      </div>
                      <div className="fg">
                        <label>Message *</label>
                        <textarea value={form.message} onChange={e => set('message', e.target.value)} rows={5} placeholder="Tell us what's on your mind…" className={errors.message ? 'error' : ''} />
                        {errors.message && <div className="field-error">{errors.message}</div>}
                      </div>
                      <button type="submit" className="btn-grad" style={{ width: '100%', padding: '14px', justifyContent: 'center' }} disabled={loading}>
                        {loading ? <><span className="spinner" /> Sending…</> : 'Send message →'}
                      </button>
                    </form>
                  </>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
